
export class ContactSubscriptionRequest {

  public unsubscribeFromMarketingEmails: boolean;

  public  agentCompanyName: string;
}
